import {API } from "./API_CONFIG";

export const EVENT_COLLECTOR_URL = API.eventCollector
export const EVENTS ={
    PC_LOGIN_INITIATE: 
    {
        name:"PC_LOGIN_INITIATE",
        schema: "iglu:com.medibuddy/PC_LOGIN_INITIATE/jsonschema/2-0-0",
        screen_name:"PC_Login_Page",
    },
    PC_LOGIN_SUCCESS: 
    {
        name:"PC_LOGIN_SUCCESS",
        schema: "iglu:com.medibuddy/PC_LOGIN_SUCCESS/jsonschema/2-0-0",
        screen_name:"PC_Login_Page",
    },
}